/**
 * VERSIONE LIBRERIA 3
 */
var RenderTexthtml = Render.extend({
    type : 'texthtml',
    classData : 'texthtml',
    classTemplate : 'texthtml',
    safeKey : null,
    tinymceConfig : null,

    init : function (key,attrs) {
        this._super(key,attrs);
        this.safeKey = key.replace(/[\])}\[{(]/g, '');
    },
    _renderView : function (jQe) {
        var self = this;
        var el = jQe.find(self.element_selector);
        el.html(self.value);
    },
    _renderEdit : function(jQe) {
        var self = this;
        var el = jQe.find(self.control_selector);
        el.attr("name", self.key);
        el.html(self.value);
    },

    _finalizeEdit: function () {
        var self = this;
        var htmlEditorId = "he_" + self.safeKey + "_";
        htmlEditorId += new Date().getTime() + "_" + _.random(0,10000);
        try {
            if ($(self.container).find('[id="' +htmlEditorId + '"]').length > 0) {
                tinyMCE.execCommand('mceRemoveControl', true,'#'+htmlEditorId);// "#"+ htmlEditorId);
            }
            $(self.container).find('[name="' + self.key + '"]').attr('id',htmlEditorId);
            if ($('#'+htmlEditorId).length == 0) {
                throw '#'+htmlEditorId + " html editor not found!";
            }
            var conf = self.tinymceConfig?self.tinymceConfig:_.clone(Render.tinymceConfig);
            conf.selector = '#'+htmlEditorId;
            tinymce.init(conf);
        } catch (e) {
            log.error(e);
        }
    },

    getValue : function () {
        var self = this;
        tinyMCE.triggerSave();
        return $(self.container).find(self.control_selector).val();
    }
});